import React, { ReactElement } from 'react';
import { Helmet } from 'react-helmet-async';
import { getConfig } from 'src/utilities/config';

export const PaymentsScript = (): ReactElement => {
  const { ccIframeUrl } = getConfig();

  return (
    <Helmet>
      <script type="text/javascript" src={ccIframeUrl} async />
    </Helmet>
  );
};
